import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditCentroCustosComponent } from './edit-centro-custos.component';


const routes: Routes = [
  {
    path: ':id',
    component: EditCentroCustosComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditCentroCustosRoutingModule { }
